export const QUESTIONS_URL = Object.freeze({
  path: '/questions',
  view: {
    name: 'question.view',
    path: '/questions/view/:id',
  },
  edit: {
    name: 'question.edit',
    path: '/questions/edit/:id',
  },
  create: {
    name: 'question.create',
    path: '/questions/create',
  },
  forbidden: {
    name: 'question.forbidden',
    path: '/questions/forbidden',
  },
  notfound: {
    name: 'question.notfound',
    path: '/questions/notfound',
  },
  denied: {
    name: 'question.denied',
    path: '/questions/denied',
  },
});

export const QUESTION_ERRORS = {
  404: 'QUESTION_NOT_FOUND',
  401: 'PERMISSION_DENIED',
};

export const QUESTION_ACCESS_INFO = {
  0: 'public-question-access-info',
  1: 'department-question-access-info',
};
